/**
 * @author Iulian Ceapa <dev@sitemd.net>
 * @copyright © 2019-2026 SiteMD.
 */

const swiper_section_3 = new Swiper('#section-3 .swiper', {
    // autoHeight: true,
    breakpoints: {
        0: {
            slidesPerView: 'auto',
            spaceBetween: 16
        },
        768: {
            slidesPerView: 'auto',
            spaceBetween: 24
        },
        1200: {
            slidesPerView: 5,
        }
    },
    grabCursor: true,
    slidesPerView: 5,
    spaceBetween: 20,
    loop: false
});

const swiper_section_4 = new Swiper('#section-4 .swiper', {
    // autoHeight: true,
    // breakpoints: {
    //     0: {
    //         slidesPerView: 'auto',
    //         spaceBetween: 16
    //     },
    //     768: {
    //         slidesPerView: 'auto',
    //         spaceBetween: 24
    //     },
    //     1200: {
    //         slidesPerView: 5,
    //     }
    // },
    grabCursor: true,
    slidesPerView: 5,
    spaceBetween: 20,
    loop: false,
    grid: {
        rows: 2,
    },
    // pagination: {
    //     el: ".swiper-pagination",
    //     clickable: true,
    // },
});